import { render, staticRenderFns } from "./detailsNotify.vue?vue&type=template&id=21170969&scoped=true&"
import script from "./detailsNotify.vue?vue&type=script&lang=js&"
export * from "./detailsNotify.vue?vue&type=script&lang=js&"
import style0 from "./detailsNotify.vue?vue&type=style&index=0&id=21170969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21170969",
  null
  
)

export default component.exports